import React from 'react';
import { Facebook, Instagram, Mail } from 'lucide-react';

const styles = {
    container: {
        backgroundColor: '#D9D9D9',
        borderRadius: '20px',
        padding: '60px 5%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '30px',
        maxWidth: '700px',
        marginBottom: '100px',
        boxSizing: 'border-box',
    },
    title: {
        fontFamily: "'Libre Baskerville', serif",
        fontSize: '28px',
        fontWeight: 700,
        textAlign: 'center',
        lineHeight: 1.3,
        color: '#000',
    },
    iconsRow: {
        display: 'flex',
        gap: '40px',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    iconLink: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        color: '#000',
        transition: 'transform 0.2s ease, color 0.2s ease',
        textDecoration: 'none',
        fontFamily: "'Libre Baskerville', serif",
        fontSize: '20px',
        fontWeight: 500,
    },
};

const ContactSquare = () => {
    return (
        <div style={styles.container}>
            <div style={styles.title}>Contact</div>
            <div style={styles.iconsRow}>
                <a
                    href="https://www.facebook.com/share/16R1uic6rS/?mibextid=wwXIfr"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.iconLink}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1.0)')}
                >
                    <Facebook size={30} />
                    <span>Sadie Lindquist</span>
                </a>

                <a
                    href="https://www.instagram.com/sadie_lindquist?igsh=Mm02NGFoZzFsMjJo&utm_source=qr"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.iconLink}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1.0)')}
                >
                    <Instagram size={30} />
                    <span>@sadie_lindquist</span>
                </a>

                <a
                    href="mailto:Lindquistsadie@gmail.com"
                    style={styles.iconLink}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1.0)')}
                >
                    <Mail size={30} />
                    <span>Lindquistsadie@gmail.com</span>
                </a>
            </div>
        </div>
    );
};

export default ContactSquare;
